//src/design-system/Molecules/ConfirmationModal/index.tsx

import React from "react";
import { Modal } from "@/design-system/Atoms/Modal";
import { Button, Typography } from "@/design-system/Atoms";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Thank you!"
      size="lgPlus"
      className="max-h-screen"
      childrenClassName="max-h-[calc(100vh-120px)]"
    >
      <div className="p-6">
        <div className="relative prose prose-sm max-w-none"> 
          <Typography
            variant="sectionDescriptionExtraSmall"
            as="p"
            className="mb-6"
          >
            All required videos confirmed. You’re ready to place your order.
          </Typography>
          <div className="flex justify-end">
            <Button variant="secondary" onClick={onClose}>
              Okay
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
